/* ZEPHIR - Afina el tope de 4 circulos de color en la TARJETA y anade el "+N".
 *
 * El tope de 4 ya lo pone zephir-tarjeta.css, para que funcione aunque este
 * archivo no corra. Lo que anade el JS son las dos cosas que el CSS no puede:
 *
 *   1. NO CONTAR LOS AGOTADOS. El tema esconde los colores sin stock con
 *      .t4s-pr-color__item.t4s-pr-color--sold-out { display: none }. Para el
 *      CSS siguen siendo hijos, asi que un :nth-child(n+5) gasta huecos en
 *      circulos que nadie ve. Caso real reproducido: 6 colores con los dos
 *      primeros agotados -> se veian DOS en vez de cuatro.
 *
 *   2. EL "+N". El cliente lo pidio: "si hay mas indicar que hay mas". El CSS
 *      no sabe contar.
 *
 * Contar solo los comprables es ademas lo honesto: un "+3" que incluyera
 * colores agotados le prometeria a la clienta opciones que no puede comprar.
 *
 * ---------------------------------------------------------------------------
 * POR QUE EL DISPLAY SE PONE EN LINEA Y CON !important
 * ---------------------------------------------------------------------------
 * Hasta el 2026-08-31 el CSS de los rieles llevaba
 *     #shopify-section-... .zph-slide .t4s-pr-color__item:nth-child(n+5)
 *     { display: none }
 * y ese selector empieza por un ID: entre dos declaraciones !important decide la
 * especificidad, y un ID le gana a cualquier numero de clases (la comparacion es
 * por componentes, asi que repetir clases no sirve). Intente anularlo desde la
 * hoja con (0,5,0) + !important y perdio.
 *
 * Esa regla YA SE QUITO de sections/zephir-product-rail.liquid, asi que hoy
 * bastaria una clase. Se mantiene el display en linea A PROPOSITO: en este
 * archivo la historia dice que las reglas de seccion aparecen y desaparecen tres
 * veces en dos dias, y una declaracion en el atributo style con !important manda
 * sobre cualquier regla de hoja de autor sin tener que repetir el id de cada
 * seccion (que ademas cambia con la plantilla). Es la unica pieza que no se
 * puede romper desde fuera.
 *
 * NO SE INVENTA EL VALOR de display: se lee del primer circulo que el tema esta
 * pintando de verdad, y solo si no hay ninguno se cae a 'flex'. Asi vale igual
 * en el inicio, en coleccion o donde el tema use otro valor.
 *
 * SE RESPETA LO QUE EL TEMA ESCONDE: los agotados y los que el tema marca con
 * .is-c (los esconde base.css) no se tocan nunca. Forzarlos visibles seria
 * ensenar colores que no se pueden comprar.
 *
 * ---------------------------------------------------------------------------
 * EL TEMA TRAE SU PROPIA VERSION DE ESTO, Y ESTA APAGADA
 * ---------------------------------------------------------------------------
 * Ajustes `sw_limit: false` y `sw_num: 10` en config/settings_data.json, que
 * gobiernan las clases t4s-pr-item-sw-limit, is-t4s--limit, is-t4s--calced e
 * is-c, y un indicador .is--colors-more con su "+N" via content en theme.css.
 * Comprobado el 2026-08-31: 0 apariciones en el marcado.
 *
 * Si se enciende con sw_num: 4, ESTE ARCHIVO Y EL TOPE DEL CSS SE DEBEN RETIRAR
 * -- dos limitadores peleandose es peor que ninguno. No se probo el nativo
 * porque encenderlo cambia las tarjetas de TODA la tienda y es un ajuste global
 * que merece su propia revision; queda anotado como la salida mas limpia.
 *
 * ---------------------------------------------------------------------------
 * POR QUE UN OBSERVADOR Y NO UN setTimeout -- la parte que me costo aprender
 * ---------------------------------------------------------------------------
 * El marcado del servidor NO trae los colores. pr-loop-item suelta tres
 * marcadores vacios (bg_color_ntloading) y el JS del tema
 * (interactable.min.js) los sustituye DESPUES, leyendo data-color-options.
 * Y TARDA MUCHO: cronometrado en la pagina real, el relleno ocurrio a los
 * VEINTIOCHO SEGUNDOS. Midiendo a los cinco todavia habia 102 marcadores y 0
 * colores reales, y de ahi saque dos veces la conclusion falsa de que los
 * circulos eran decorativos y que nadie los rellenaba; sobre esa conclusion
 * llegue a retirar este archivo. Un temporizador acertaria unas veces y otras
 * no; y las colecciones con scroll infinito meten tarjetas nuevas mucho
 * despues.
 *
 * POR QUE SE OCULTA Y NO SE BORRA: el tema vuelve a tocar esos nodos (al pulsar
 * un circulo cambia la foto de la tarjeta). Si se borran, puede fallar al
 * buscarlos.
 */
(function () {
  'use strict';

  var TOPE = 4;
  var MARCA = 'data-zph-color-n';   // cuantos comprables habia la ultima vez

  /* Los que la clienta puede ver y pulsar: ni agotados ni escondidos por el
     propio tema, ni el "+N" nativo si algun dia se enciende. */
  function comprables(caja) {
    var todos = caja.querySelectorAll('.t4s-pr-color__item');
    var out = [];
    for (var i = 0; i < todos.length; i++) {
      if (todos[i].classList.contains('t4s-pr-color--sold-out')) continue;
      if (todos[i].classList.contains('is-c')) continue;
      if (todos[i].classList.contains('is--colors-more')) continue;
      out.push(todos[i]);
    }
    return out;
  }

  /* El display que el tema usa aqui, sin inventarlo. */
  function displayDelTema(items) {
    for (var i = 0; i < items.length; i++) {
      var d = getComputedStyle(items[i]).display;
      if (d && d !== 'none') return d;
    }
    return 'flex';
  }

  function recortar(caja) {
    var items = comprables(caja);
    if (items.length === 0) return;                 // el tema aun no ha pintado

    var visible = displayDelTema(items);

    var viejo = caja.querySelector('.zph-color-mas');
    if (viejo) viejo.parentNode.removeChild(viejo);

    for (var i = 0; i < items.length; i++) {
      if (i < TOPE) {
        items[i].classList.remove('zph-color-oculto');
        items[i].style.setProperty('display', visible, 'important');
      } else {
        items[i].classList.add('zph-color-oculto');
        items[i].style.setProperty('display', 'none', 'important');
      }
    }

    var sobran = items.length - TOPE;
    if (sobran > 0) {
      var mas = document.createElement('span');
      mas.className = 'zph-color-mas';
      mas.setAttribute('aria-label', sobran + (sobran === 1 ? ' color mas' : ' colores mas'));
      mas.textContent = '+' + sobran;
      caja.appendChild(mas);
    }

    caja.classList.add('zph-color-js');
    caja.setAttribute(MARCA, String(items.length));
  }

  function repasar(raiz) {
    var cajas = (raiz || document).querySelectorAll('.t4s-product-colors');
    for (var i = 0; i < cajas.length; i++) {
      var c = cajas[i];
      var n = comprables(c).length;
      if (c.getAttribute(MARCA) === String(n)) continue;   // sin cambios
      recortar(c);
    }
  }

  function arrancar() {
    repasar(document);
    if (!('MutationObserver' in window)) return;   // al menos el primer repaso
    var pendiente = null;
    var obs = new MutationObserver(function () {
      if (pendiente) return;                      // se agrupan los cambios
      pendiente = setTimeout(function () { pendiente = null; repasar(document); }, 80);
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }
  document.addEventListener('shopify:section:load', function () { repasar(document); });
})();
